module.exports = __webpack_public_path__ + "img/services-icon-4.bafff1d0.png";